// extracted by mini-css-extract-plugin
module.exports = {"resultsTitle":"_2mNI0YaNiNM-ZMnV48DOp","seeMore":"_2Nqi4eteruc0wLk453bjwu"};